export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Flip to "app" on go-live. Every CTA must route through this.
export const CTA_MODE = "lead";
export const APP_URL = "https://app.nightbay.in";

export const WA_NUMBER = "919741146164";
export const SUPPORT_PHONE = "+91 97411 46164";
export const SUPPORT_EMAIL = "support@nightbay.in";

export const LOCALITIES = [
  "Nagarbhavi",
  "Vijayanagar",
  "Rajajinagar",
  "Jayanagar",
  "BTM Layout",
  "HSR Layout",
  "Koramangala",
  "Indiranagar",
  "Whitefield",
  "Electronic City",
];

export const WA_TEXT = {
  renter: "Hi NightBay, I'm looking for monthly night parking in ______ (locality).",
  host: "Hi NightBay, I have ______ parking bay(s) to rent out in ______ (locality).",
  general: "Hi NightBay, I have a question about monthly night parking.",
};

export const waLink = (kind = "general") =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_TEXT[kind] || WA_TEXT.general)}`;

export const FALLBACK_STATS = {
  live_bays: 0,
  available_bays: 0,
  localities_live: 0,
  localities_total: 10,
  typical_price: null,
  platform_fee_inr: 300,
  cancellation_notice_days: 15,
  listing_fee_inr: 499,
  bundle_fee_inr: 1999,
  bundle_min_spots: 5,
  bundle_large_fee_inr: 2999,
  bundle_large_min_spots: 6,
  managed_free_min_spots: 11,
  free_slots_left: 50,
  free_duration_days: 365,
};

export const TYPICAL_PRICE_FALLBACK = "\u20b91,200\u2013\u20b94,500";

export const appHref = (side) =>
  side === "host" ? `${APP_URL}/list-spot` : `${APP_URL}/`;
